var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.login)?_c('v-app',{attrs:{"id":"inspire"}},[_c('Menu'),_c('v-main',[_c('router-view')],1),_c('Footer')],1):_c('Login')],1)}
var staticRenderFns = []

export { render, staticRenderFns }